/*
 * The card-payment offer in the cart.
 *
 * Ticking it applies the discount code and stamps the cart attribute that the
 * checkout payment function reads. The tick is only kept if Shopify confirms
 * the code applied: another order discount in the cart blocks it, and leaving
 * the box ticked would cost the shopper cash on delivery for nothing.
 */
(function () {
  if (customElements.get('kd-pay-choice')) return;

  var ATTRIBUTE = 'plata';
  var CARD = 'card';

  function cartUrl() {
    return (window.FoxTheme && window.FoxTheme.routes && window.FoxTheme.routes.cart_url) || '/cart';
  }

  function getCart() {
    return fetch(cartUrl() + '.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  class KdPayChoice extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-kd-pay-toggle]');
      this.errorEl = this.querySelector('[data-kd-pay-error]');
      this.box = this.querySelector('.kd-pay');
      this.code = (this.dataset.code || '').trim();
      if (!this.toggle || !this.code) return;

      this.onChange = this.handleChange.bind(this);
      this.toggle.addEventListener('change', this.onChange);
    }

    disconnectedCallback() {
      if (this.toggle) this.toggle.removeEventListener('change', this.onChange);
    }

    setBusy(busy) {
      if (this.box) this.box.classList.toggle('is-busy', busy);
    }

    showError(message) {
      if (!this.errorEl) return;
      this.errorEl.textContent = message || '';
      this.errorEl.hidden = !message;
    }

    handleChange() {
      var self = this;
      var wanted = this.toggle.checked;
      this.setBusy(true);
      this.showError('');

      getCart()
        .then(function (cart) {
          // Whatever else the shopper already applied has to survive: the
          // discount field replaces the whole list, it does not append.
          var codes = (cart.discount_codes || [])
            .filter(function (d) { return d.applicable; })
            .map(function (d) { return d.code; })
            .filter(function (c) { return c.toUpperCase() !== self.code.toUpperCase(); });

          if (wanted) codes.push(self.code);

          var sections = [];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sections } })
          );

          var attributes = {};
          attributes[ATTRIBUTE] = wanted ? CARD : '';

          return fetch(cartUrl() + '/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({
              discount: codes.join(','),
              attributes: attributes,
              sections: sections,
              sections_url: window.location.pathname
            })
          }).then(function (r) { return r.json(); });
        })
        .then(function (state) {
          var applied = (state.discount_codes || []).some(function (d) {
            return d.code.toUpperCase() === self.code.toUpperCase() && d.applicable;
          });

          if (wanted && !applied) {
            // Roll the whole thing back rather than leave the cart stamped for
            // card payment without the discount that pays for it.
            self.toggle.checked = false;
            self.showError(self.dataset.conflict || '');
            return self.rollback(state);
          }

          return self.refresh(state);
        })
        .catch(function () {
          self.toggle.checked = !wanted;
          self.showError(self.dataset.conflict || '');
        })
        .then(function () { self.setBusy(false); });
    }

    rollback(state) {
      var self = this;
      var codes = (state.discount_codes || [])
        .filter(function (d) { return d.applicable; })
        .map(function (d) { return d.code; })
        .filter(function (c) { return c.toUpperCase() !== self.code.toUpperCase(); });
      var attributes = {};
      attributes[ATTRIBUTE] = '';

      return fetch(cartUrl() + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ discount: codes.join(','), attributes: attributes })
      })
        .then(function (r) { return r.json(); })
        .then(function (after) { return self.refresh(after); });
    }

    // Hand the fresh cart to the theme so totals, the drawer and the discount
    // list all redraw from one source.
    refresh(state) {
      return getCart().then(function (cart) {
        cart.sections = state.sections;
        var fox = window.FoxTheme;
        if (fox && fox.pubsub && fox.pubsub.PUB_SUB_EVENTS) {
          fox.pubsub.publish(fox.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      });
    }
  }

  customElements.define('kd-pay-choice', KdPayChoice);
})();
